import { Api } from '@mui/icons-material';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

let nextId = 2;

export const sendMessageToServer = createAsyncThunk(
  'chat/sendMessageToServer',
  async ({ message, meta }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const sessionId = state.resortShellySlice.sessionId || meta.sessionId;

      const payload = {
        sessionId,
        message,
        brand: meta.brand,
        interface: meta.interface,
        hotelCode: meta.hotelCode,
        destination: meta.destination,
      };
      const res = await axios.post(
        'https://aichatassistantdev.kindsea-af1e968e.eastus.azurecontainerapps.io/api/hotelchat/prompt',
        payload
      ); 

      if (res.data.errorMessage) {
        return thunkAPI.rejectWithValue(res.data.errorMessage);
      }

      let assistantReply = res.data.data?.assistantReply || '';
      assistantReply = assistantReply.replace(/\n/g, '<br />');
      const updatedSessionId = res.data.data?.sessionId || sessionId;

      return { reply: assistantReply, sessionId: updatedSessionId };
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.errorMessage || "Network error. Please try again."
      );
    }
  }
);
const initialState = {
  sessionId: null,
  messages: [
    {
      id: 1,
      sender: 'bot',
      text: 'Hello! How can I assist you today?',
    },
  ],
  loading: false,
  lastFailed: null,
};

const resortSlice = createSlice({
  name: 'resortShellySlice',
  initialState,
  reducers: {
    resetChat: (state) => {
      state.messages = [
        {
          id: 1,
          sender: 'bot',
          text: 'Hello! How can I assist you today?',
        },
      ];
      state.loading = false;
      state.lastFailed = null;
      state.sessionId = null; // ⬅️ Reset sessionId
      nextId = 2;
    },
    sendMessage: (state, action) => {
      state.messages.push({
        id: nextId++,
        sender: 'customer',
        text: action.payload,
      });
    },
    clearLastFailed: (state) => {
      state.lastFailed = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessageToServer.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendMessageToServer.fulfilled, (state, action) => {
        state.loading = false;
        state.lastFailed = null;
        if (action.payload.sessionId) {
          state.sessionId = action.payload.sessionId; // ✅ Persisted session ID
        }
        state.messages.push({
          id: nextId++,
          sender: 'bot',
          text: action.payload.reply, 
        });
      })
      .addCase(sendMessageToServer.rejected, (state, action) => {
        state.loading = false;
        const originalArgs = action.meta.arg;
        state.lastFailed = originalArgs;

        state.messages.push({
          id: nextId++,
          sender: 'bot',
          text: `⚠️ ${action.payload || 'Something went wrong.'}`,
          type: 'error',
        });
      });
  },
});

export const { sendMessage, clearLastFailed,resetChat  } = resortSlice.actions;
export default resortSlice.reducer;
